<!-- 
Dialog that will be displayed the first time a user opens a new levy collection.
-->
<template>
  <v-dialog :value="show" persistent content-class="dialog sm">
    <v-card>
      <v-toolbar color="secondary" flat dark>
        <v-toolbar-title>{{ levyCollectionDescription }} levy collection initial setup</v-toolbar-title>
      </v-toolbar>
      <our-busy-indicator :show="saving"/>
      <v-card-text>
        <p class="body-2">
          Welcome to the {{ levyCollectionDescription }} levy collection.
        </p>
        <p>
          The first steps in preparing a levy collection involve reviewing and editing the various parameters and templates
          that were copied over from the prior year's levy collection. 
        </p>
        <p>
          If you are not sure whether something needs to be changed, you can always skip over it and come back to it later. 
          You can return to this screen later by clicking on <i>Setup</i> in the navigation sidebar.
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn :disabled="saving" flat color="primary" @click="done">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import * as action from "@/store/levy-collections/action-types";
import lookupMixins from "@/mixins/lookup.mixins";

export default {
  mixins: [lookupMixins],
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    levyCollection: {
      type: Object,
      required: true
    }
  },
  computed: {
    levyCollectionDescription() {
      const lc = this.levyCollection;
      return `${lc.year} ${this.lookups.levyCollectionTypeDescriptions[lc.type]}`;
    },
    saving() {
      return this.$store.state.levyCollections.setup.saving;
    }
  },
  methods: {
    async done() {
      await this.$store.dispatch(action.FINISH_SETUP, this.levyCollection.id);
      this.$emit("update:show", false);
    }
  }
};
</script>
